export default __webpack_public_path__ + "static/media/logo-nasa.b4e79ad9.svg";